import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const startedAt = Date.now();

function pad(value: number): string {
  return value.toString().padStart(2, "0");
}

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - startedAt) / 1000);
  const remaining = DURATION_SECONDS - (elapsed % DURATION_SECONDS);

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  };
}
